module.exports = __webpack_public_path__ + "static/media/light_and_airy_8.2ac8606c.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/light_and_airy_8.JPG
// module id = 259
// module chunks = 0